<template>
    <v-tooltip v-if="toolTip || !showText" :top="toolTipGravity === 'TOP'" :bottom="toolTipGravity === 'BOTTOM'" :content-class="computedTooltips">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="isText" @click="emitClick" v-bind="attrs" v-on="on" :class="computedClasses" text>
                <span class="mr-5 button-text" v-if="text && showText && !iconStart">{{ text }}</span>
                <v-icon v-if="isIcon" :class="iconColorClass">{{ iconString }}</v-icon>
                <img v-else-if="isImage" height="50" width="50" :src="iconString" />
                <inline-svg v-else-if="isSVG" :class="iconColorClass" :src="iconString" class="logo">
                </inline-svg>
                <span class="ml-5 button-text" v-if="text && showText && iconStart">{{ text }}</span>
            </v-btn>
            <v-btn v-if="isTile" @click="emitClick" v-bind="attrs" v-on="on" :class="computedClasses" tile>
                <span class="mr-5 button-text" v-if="text && showText && !iconStart">{{ text }}</span>
                <v-icon v-if="isIcon" :class="iconColorClass">{{ iconString }}</v-icon>
                <img class="my-2" v-else-if="isImage" height="50" width="50" :src="iconString" />
                <inline-svg v-else-if="isSVG" :class="iconColorClass" :src="iconString" class="logo">
                </inline-svg>
                <span class="ml-5 button-text" v-if="text && showText && iconStart">{{ text }}</span>
            </v-btn>
        </template>
        <span>{{ toolTip || text }}</span>
    </v-tooltip>
    <v-btn v-else-if="isText" @click="emitClick" :class="computedClasses" text>
        <span class="mr-2 button-text" v-if="text && showText && !iconStart">{{ text }}</span>
        <v-icon :class="iconColorClass" v-if="isIcon">{{ iconString }}</v-icon>
        <img v-else-if="isImage" height="50" width="50" :src="iconString" />
        <inline-svg v-else-if="isSVG" :class="iconColorClass" :src="iconString" class="logo">
        </inline-svg>
        <span class="ml-2 button-text" v-if="text && showText && iconStart">{{ text }}</span>
    </v-btn>
    <v-btn v-else-if="isTile" @click="emitClick" :class="computedClasses" tile>
        <span class="mr-2 button-text" v-if="text && showText && !iconStart">{{ text }}</span>
        <v-icon :class="iconColorClass" v-if="isIcon">{{ iconString }}</v-icon>
        <img v-else-if="isImage" height="50" width="50" :src="iconString" />
        <inline-svg v-else-if="isSVG" :class="iconColorClass" :src="iconString" class="logo">
        </inline-svg>
        <span class="ml-2 button-text" v-if="text && showText && iconStart">{{ text }}</span>
    </v-btn>
</template>

<style lang="scss" scoped>
@import '../../styles/styles.scss';

.tall-button{
    height: 60px !important;
}

.logo{
    height: 50px;
    width: 50px;
}

.logo ::v-deep.svg{
    cursor: pointer;
}

.button-text {
    display: block;
    word-wrap: normal;
    white-space: normal
}
</style>

<script>
import * as IconTypes from '../../assets/Enums/IconTypeEnum';
import * as ButtonTypes from '../../assets/Enums/ButtonTypeEnums';
import * as IconPositions from '../../assets/Enums/IconPositionEnums';
import SvgInline from 'vue-inline-svg';

export default {
    components:{
        'inline-svg': SvgInline
    },
    props: {
        iconPosition: {
            type: String,
            default: 'START'
        },
        iconString: {
            type: String,
            default: '',
        },
        toolTip: {
            type: String,
            default: '',
        },
        iconType: {
            type: String,
            default: IconTypes.ICON,
        },
        text: {
            type: String,
            default: '',
        },
        colNum: {
            type: Number,
            default: 3,
        },
        btnType: {
            type: String,
            default: ButtonTypes.TEXT,
        },
        colorClasses: {
            type: String,
            default: '',
        },
        toolTipClasses: {
            type: String,
            default: ''
        },
        marginNumber: {
            type: Number,
            default: 1,
        },
        toolTipGravity: {
            type: String,
            default: 'TOP',
        },
        iconColor:{
            types: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        emitClick(){
            this.$emit('click-event')
        }
    },
    computed: {
        isIcon() {
            return this.iconType === IconTypes.ICON
        },
        isImage() {
            return this.iconType === IconTypes.IMAGE
        },
        isSVG(){
            return this.iconType === IconTypes.SVG
        },
        colClass() {
            return 'col-' + this.colNum
        },
        computedClasses() {
            return this.colClass + ' ' + this.colorClasses + ' mx-' + this.marginNumber + ' tall-button';
        },
        computedTooltips() {
            return this.toolTipClasses ? this.toolTipClasses : 'secondary-icon';
        },
        iconColorClass(){
            return this.iconColor;
        },
        isTile() {
            return this.btnType === ButtonTypes.TILE;
        },
        isText() {
            return this.btnType === ButtonTypes.TEXT;
        },
        iconStart(){
            return this.iconPosition === IconPositions.START;
        },
        showText(){
            if(this.isIcon || this.isImage || this.isSVG){
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs':
                        return false;
                    case 'sm':
                        return false;
                    case 'md':
                        return true;
                    case 'lg':
                        return true;
                    case 'xl':
                        return true;
                    default:
                        return true;
                }
            }
            return true;
        }
    },
}
</script>
